import { ShareNetworkIcon as PhosphorShareNetworkIcon } from "@phosphor-icons/react/dist/ssr/ShareNetwork";

import { createAppIcon } from "@/components/createAppIcon";

export const ShareIcon = /* @__PURE__ */ createAppIcon(PhosphorShareNetworkIcon);
